export default __webpack_public_path__ + "assets/e10ad6b99e4b4e05462e75743d2ac6d9.jpg";